import { IContextMenuModal } from '@legacy/apis/pagesAPI/designSevenAPI/types';
import MileageRegistration from '@legacy/screens/PageActionsModal/MileageRegistration';

export default {
  wrongId: {
    childComponent: (
      <p data-automation-id="wrongId">
        Please setup your modal id in constants/screenHeaderModalItem.tsx
      </p>
    ),
  },
  32: {
    childComponent: <MileageRegistration />,
  },
} as Record<
  string,
  Pick<IContextMenuModal, 'childComponent' | 'headingComponent'>
>;
